import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88c01420"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "userManageView" }

import { onMounted, reactive, ref } from "vue";
import { UserControllerService, User } from "../../../generated";
import message from "@arco-design/web-vue/es/message";
import moment from "moment";
import { IconPlus } from "@arco-design/web-vue/es/icon";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserManageView',
  setup(__props) {

const dataList = ref<User[]>([]);
const total = ref(0);
const searchParams = ref({
  userName: "",
  userRole: "",
  current: 1,
  pageSize: 15,
});

const loadData = async () => {
  const params: any = {
    current: searchParams.value.current,
    pageSize: searchParams.value.pageSize,
  };
  if (searchParams.value.userName) {
    params.userName = searchParams.value.userName;
  }
  if (searchParams.value.userRole) {
    params.userRole = searchParams.value.userRole;
  }
  const res = await UserControllerService.listUserByPageUsingPost(params);
  if (res.code === 0) {
    dataList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error("加载失败，" + res.message);
  }
};

onMounted(() => {
  loadData();
});

const columns = [
  { title: "ID", dataIndex: "id", width: 70 },
  { title: "用户名", dataIndex: "userName" },
  { title: "账号", dataIndex: "userAccount" },
  { title: "角色", slotName: "userRole", width: 100 },
  { title: "创建时间", slotName: "createTime", width: 170 },
  { title: "操作", slotName: "optional", width: 130 },
];

const onPageChange = (page: number) => {
  searchParams.value.current = page;
  loadData();
};

const doSearch = () => {
  searchParams.value.current = 1;
  loadData();
};

// 弹窗相关
const modalVisible = ref(false);
const modalLoading = ref(false);
const isEdit = ref(false);
const editingId = ref<number | undefined>();
const modalForm = reactive({
  userAccount: "",
  userName: "",
  userRole: "user",
});

const openAddModal = () => {
  isEdit.value = false;
  editingId.value = undefined;
  modalForm.userAccount = "";
  modalForm.userName = "";
  modalForm.userRole = "user";
  modalVisible.value = true;
};

const openEditModal = (record: User) => {
  isEdit.value = true;
  editingId.value = record.id;
  modalForm.userName = record.userName || "";
  modalForm.userRole = record.userRole || "user";
  modalVisible.value = true;
};

const resetModal = () => {
  modalForm.userAccount = "";
  modalForm.userName = "";
  modalForm.userRole = "user";
};

const handleModalOk = async () => {
  modalLoading.value = true;
  try {
    let res;
    if (isEdit.value) {
      res = await UserControllerService.updateUserUsingPost({
        id: editingId.value,
        userName: modalForm.userName,
        userRole: modalForm.userRole,
      });
    } else {
      res = await UserControllerService.addUserUsingPost({
        userAccount: modalForm.userAccount,
        userName: modalForm.userName,
        userRole: modalForm.userRole,
      });
    }
    if (res.code === 0) {
      message.success(isEdit.value ? "修改成功" : "新增成功");
      modalVisible.value = false;
      loadData();
    } else {
      message.error((isEdit.value ? "修改" : "新增") + "失败，" + res.message);
    }
  } finally {
    modalLoading.value = false;
  }
};

const doDelete = async (record: User) => {
  const res = await UserControllerService.deleteUserUsingPost({
    id: record.id,
  });
  if (res.code === 0) {
    message.success("删除成功");
    loadData();
  } else {
    message.error("删除失败，" + res.message);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, {
      title: "用户管理",
      bordered: false
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: openAddModal
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(IconPlus))
          ]),
          default: _withCtx(() => [
            _createTextVNode(" 新增用户 ")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: searchParams.value,
          layout: "inline",
          style: {"margin-bottom":"16px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              field: "userName",
              label: "用户名"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: searchParams.value.userName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.userName) = $event)),
                  placeholder: "搜索用户名",
                  "allow-clear": "",
                  onPressEnter: doSearch
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "userRole",
              label: "角色"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  modelValue: searchParams.value.userRole,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.userRole) = $event)),
                  placeholder: "全部",
                  "allow-clear": "",
                  style: {"width":"120px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_option, { value: "user" }, {
                      default: _withCtx(() => [
                        _createTextVNode("普通用户")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_option, { value: "admin" }, {
                      default: _withCtx(() => [
                        _createTextVNode("管理员")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: doSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("搜索")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_a_table, {
          columns: columns,
          data: dataList.value,
          pagination: {
          showTotal: true,
          pageSize: searchParams.value.pageSize,
          current: searchParams.value.current,
          total: total.value,
        },
          onPageChange: onPageChange,
          "row-key": "id"
        }, {
          userRole: _withCtx(({ record }) => [
            _createVNode(_component_a_tag, {
              color: record.userRole === 'admin' ? 'orangered' : 'arcoblue'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(record.userRole === "admin" ? "管理员" : "普通用户"), 1)
              ]),
              _: 2
            }, 1032, ["color"])
          ]),
          createTime: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD HH:mm")), 1)
          ]),
          optional: _withCtx(({ record }) => [
            _createVNode(_component_a_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  size: "small",
                  type: "text",
                  onClick: ($event: any) => (openEditModal(record))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 编辑 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_a_popconfirm, {
                  content: "确定删除该用户吗？",
                  onOk: ($event: any) => (doDelete(record))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      size: "small",
                      type: "text",
                      status: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 删除 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onOk"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["data", "pagination"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: modalVisible.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((modalVisible).value = $event)),
      title: isEdit.value ? '编辑用户' : '新增用户',
      onOk: handleModalOk,
      "ok-loading": modalLoading.value,
      onCancel: resetModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: modalForm,
          layout: "vertical"
        }, {
          default: _withCtx(() => [
            (!isEdit.value)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  field: "userAccount",
                  label: "账号",
                  rules: [{ required: true, message: '请输入账号' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      modelValue: modalForm.userAccount,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modalForm.userAccount) = $event)),
                      placeholder: "请输入账号"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form_item, {
              field: "userName",
              label: "用户名"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: modalForm.userName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modalForm.userName) = $event)),
                  placeholder: "请输入用户名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "userRole",
              label: "角色"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  modelValue: modalForm.userRole,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modalForm.userRole) = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_option, { value: "user" }, {
                      default: _withCtx(() => [
                        _createTextVNode("普通用户")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_option, { value: "admin" }, {
                      default: _withCtx(() => [
                        _createTextVNode("管理员")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "title", "ok-loading"])
  ]))
}
}

})